import { createContext } from "react";
import { DarkModeContextType } from "@/types/contextTypes";

export const DarkModeContext = createContext<DarkModeContextType | undefined>(
  undefined,
);
